/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
/**
 *
 * @param {Object} item
 * @returns
 */
const LandscapeComponent = ({ item, backgroundStyle }) => {
  // Set text color to black only if backgroundStyle is 'amber'
  const textColorBase = backgroundStyle === 'amber' ? 'black' : '#F1EDE9';

  return (
    <Box
      height={{ lg: '247px', '2xl': '314px', md: '312px', base: 'auto' }}
      width="100%"
      maxW={{ lg: '370.6px', '2xl': '468px' }}
      objectFit="cover"
      position="relative"
      _hover={{ '.textBox': { display: 'block' } }}
    >
      <LazyLoadImageComponent
        src={item.image.url}
        alt={item.image.alt || 'Gallery image'}
        height={{ md: '100%', base: 'auto' }}
        width="100%"
        objectFit="cover"
      />
      {item.image.alt && (
        <Box
          className="textBox"
          p={{ md: '0.5rem', base: '0.5rem 1rem' }}
          position={{ md: 'absolute', base: 'relative' }}
          bottom={{ md: '0', base: 'auto' }}
          width="100%"
          fontWeight={400}
          fontSize={{ md: '1rem', base: '0.875rem' }}
          fontFamily="var(--FedraSansStd-book)"
          letterSpacing="2%"
          lineHeight={{ md: '1.6rem', base: '1.4rem' }}
          bg={{ md: '#010509CC', base: 'transparent' }}
          display={{ base: 'block', md: 'none' }}
        >
          <Text
            color={{ base: textColorBase, md: '#F1EDE9' }}
            fontWeight={400}
            fontSize={{ base: '.875rem' }}
            lineHeight={{ base: '1.4rem' }}
            fontFamily="var(--FedraSansStd-book)"
            letterSpacing={'0.32px'}
          >
            {item.image.alt}
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default LandscapeComponent;
